import { FileDownloadService } from "@topline/services/fileDownloadService";
import { ToasterService } from "@topline/services/toasterService";
(module => {
    "use strict";

    module.component("quarterTable", {
        template: require("./quarterTableComponent.html"),
        bindings: {
            startDate: "<",
            endDate: "<",
            displayValues: "<",
            name: "@",
            numberPrecision: "@",
            showInMilions: "<"
        },
        controller: [
            "$scope",
            "$timeout",
            "PPGChartAndTableService",
            ToasterService.componentName,
            FileDownloadService.componentName,
            function (
                this: $TSFixMe,
                $scope: $TSFixMe,
                $timeout: ng.ITimeoutService,
                PPGChartAndTableService: $TSFixMe,
                toasterService: ToasterService,
                fileDownloadService: FileDownloadService
            ) {
                const $ctrl = this;

                $ctrl.$onInit = () => {
                    if (angular.isUndefinedOrNull($ctrl.numberPrecision)) {
                        $ctrl.numberPrecision = 2;
                    }

                    $timeout(() => {
                        $ctrl.fitToWrapper = PPGChartAndTableService.fitTableToWrapper($ctrl.name);
                    }, 0);
                };

                var firstElementLength: $TSFixMe;

                $ctrl.scrollTo = (element: $TSFixMe, idx: $TSFixMe) => {
                    const wrapperToSrcroll = document.getElementById($ctrl.name),
                        elementId = $ctrl.name + "-" + element,
                        // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                        elementWidth = document.getElementById(elementId).offsetWidth,
                        scrollValue = elementWidth * idx + idx - firstElementLength * 150;
                    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                    wrapperToSrcroll.scrollLeft = 0;
                    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                    wrapperToSrcroll.scrollLeft += scrollValue;
                };

                $scope.$watchGroup(["$ctrl.startData", "$ctrl.endDate"], () => {
                    $ctrl.labels = PPGChartAndTableService.prepareLabelsToQuartersTable($ctrl.startDate, $ctrl.endDate);
                    firstElementLength = 4 - $ctrl.labels[0].quarters.length;
                });

                $ctrl.exportTable = () => {
                    toasterService.showReportGenerateBusyIndicator(
                        () =>
                            fileDownloadService.exportTable("table.xlsx", {
                                columns: _.flatten(
                                    _.map($ctrl.labels, (l: $TSFixMe) =>
                                        _.map(l.quarters, (q: $TSFixMe) => q + "/" + l.year)
                                    )
                                ),

                                rows: _.map($ctrl.displayValues, (x: $TSFixMe) => {
                                    return {
                                        header: x.header,
                                        values: x.data,
                                        decimalPlaces: x.isPercentage ? 2 : parseInt($ctrl.numberPrecision),
                                        isPercentage: x.isPercentage
                                    };
                                })
                            }),
                        "EXCEL_EXPORT_GENERATING",
                        "EXCEL_EXPORT_GENERATED"
                    );
                };
            }
        ]
    });
})(angular.module("topline.modules"));
